// extracted by mini-css-extract-plugin
module.exports = {"toasts":"toasts_toasts__tvQM-","toast":"toasts_toast__184YG","btn":"toasts_btn__10fe-"};